// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"dafb74b1","977":"cf2120fc"}[chunkId] + ".chunk.js";
};